import React from 'react';
import { RoleActiveTools } from '@/components/ai/RoleActiveTools';

/**
 * Student Active Tools Page
 * Shows the student's active AI tools from the marketplace
 */
export default function StudentAiTools() {
  return (
    <div className="mx-auto max-w-5xl px-4 py-6">
      <RoleActiveTools
        role="student"
        title="Your AI Tools"
        description="Launch your active AI tools to help with homework, studying, and learning."
        marketplacePath="/portal/student/ai-marketplace"
        showComingSoon={true}
      />
    </div>
  );
}
